import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const NegaraService = {}

NegaraService.getDataAll = function (token) {

    return fetch({
        url: '/ref/negara',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

NegaraService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/negara',
        method: 'get',
        params: {
            "id_negara":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default NegaraService;
